import { call, select, take } from 'redux-saga/effects';

import { CREATE_HIGHLIGHT } from './actions';

import { createHighlight as vsCreateHighlight } from 'services/learnkit';


function* create() {
  while (true) {
    const { data:{ markerId, noteText }}  = yield take(CREATE_HIGHLIGHT);

    yield select(state => {
      return {
        highlights: state.highlights,
        notes: state.notes
      };
    });
    const options = {
      markerId,
      noteText
    };

    // LST-1595 make api call and `highlight:created` VS event will handle updating redux state
    yield call(vsCreateHighlight, options);
  }
}


export default create;
